import { useCallback } from "react";
import type { Row } from "@tanstack/react-table";
import { SharedTable } from "shared/table";
import {
    ANCHO_MINIMO_TABLA_PRODUCTOS,
    MENSAJE_SIN_PRODUCTOS,
} from "../constants/productoSeleccionado.constants";
import { useProductoSeleccionadoTabla } from "../hooks/useProductoSeleccionadoTabla";
import type {
    FilaProductoSeleccionado,
    ProductoSeleccionadoModuloProps,
} from "../types/productoSeleccionado.types";
import { requiereComentario } from "../utils/productoSeleccionado.utils";
import { FilaComentario } from "./FilaComentario";

export const ProductoSeleccionadoModulo = ({
    detalles,
    totalPedido,
    ocultarTotal,
    handleRemoveDetalle,
    onCambiarCantidadLinea,
    onCambiarObservacionesLinea,
    deshabilitado,
    permitirOrdenar,
    paginador = true,
    tamanoPagina,
    cargando = false,
    compacta = true,
    mensajeVacio = MENSAJE_SIN_PRODUCTOS,
    anchoMinimo = ANCHO_MINIMO_TABLA_PRODUCTOS,
    acciones,
}: ProductoSeleccionadoModuloProps): JSX.Element => {
    const { control, comentarioAbierto, abiertoManualmente, cerrarComentario } = useProductoSeleccionadoTabla({
        detalles,
        totalPedido,
        ocultarTotal,
        handleRemoveDetalle,
        onCambiarCantidadLinea,
        onCambiarObservacionesLinea,
        deshabilitado,
        permitirOrdenar,
        paginador,
        tamanoPagina,
    });

    const renderSubFila = useCallback(
        (row: Row<FilaProductoSeleccionado>) => {
            const fila = row.original;
            if (!onCambiarObservacionesLinea || !comentarioAbierto(fila)) return null;

            return (
                <FilaComentario
                    comentarios={fila.observaciones}
                    obligatorio={requiereComentario(fila.clave)}
                    deshabilitado={deshabilitado}
                    enfocar={abiertoManualmente(fila.id_linea)}
                    onGuardar={(texto) => {
                        onCambiarObservacionesLinea(fila.id_linea, texto);
                        cerrarComentario(fila.id_linea);
                    }}
                />
            );
        },
        [onCambiarObservacionesLinea, comentarioAbierto, abiertoManualmente, deshabilitado, cerrarComentario]
    );

    return (
        <SharedTable
            control={control}
            cargando={cargando}
            paginador={paginador}
            compacta={compacta}
            anchoMinimo={anchoMinimo}
            mensajeVacio={mensajeVacio}
            acciones={acciones}
            renderSubFila={onCambiarObservacionesLinea ? renderSubFila : undefined}
        />
    );
};